import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import PartyWrapper from './Party';
import FilterAndPaginate from '../common/FilterAndPaginate';
import UserList from './UserList';
import Pagination from '../common/Pagination';

class PartyUserListNew extends Component {
    static propTypes = {
        paginationOptions: PropTypes.object,
        paginatedItems: PropTypes.array,
        handleSortChange: PropTypes.func,
        handlePaginationChange: PropTypes.func,
        partyStateActions: PropTypes.object,
        userStateActions: PropTypes.object,
    };

    render() {
        const {
            paginatedItems,
            handleSortChange,
            handlePaginationChange,
            paginationOptions,
            partyStateActions,
            userStateActions,
        } = this.props;

        return (
            <React.Fragment>
                <Header as="h2">Users</Header>
                {paginatedItems?.length ? (
                    <React.Fragment>
                        <UserList
                            users={paginatedItems || []}
                            paginationOptions={paginationOptions}
                            handleSortChange={handleSortChange}
                            partyStateActions={partyStateActions}
                            userStateActions={userStateActions}
                        />
                        <Pagination
                            activePage={paginationOptions.activePage}
                            onPageChange={handlePaginationChange}
                            totalPages={paginationOptions.totalPages}
                            style={{ float: 'right' }}
                        />
                    </React.Fragment>
                ) : (
                    <div className="row">
                        <div className="column">
                            <Header as="h4">
                                There are no users in this party
                            </Header>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

function mapOptions(props) {
    return {
        items: props.party.users,
    };
}

export default PartyWrapper(FilterAndPaginate(mapOptions)(PartyUserListNew));
